import http from '@/api/http'

export interface ClientVisitReportBusinessService {
  // One business service visit within a client's entry in GET `/persons/clients/visits-report`.

  business_service_type_id: string
  // Reference to the service type definition.

  business_service_name: string
  // Human-readable name, resolved server-side since this report is public.

  price: number
  // Applied price for this visit (client-business-service association).

  date: string
  // Calendar date (`YYYY-MM-DD`) the business service took place.
}

export interface ClientVisitsReportItem {
  // One row from GET `/persons/clients/visits-report`.

  client_id: string
  // Client's person id (UUID7).

  name: string
  // Client's full display name.

  latest_balance: number | null
  // Client's balance as of the 1st of the current month plus payments made so far
  // this month, or null if neither a balance nor a payment was ever recorded.
  // Non-negative means last month's debt is closed; negative means it isn't yet.

  business_services: ClientVisitReportBusinessService[]
  // One entry per business service the client visited in the period.
}

/**
 * Fetches the temporary public clients visits report for an inclusive date
 * range. Unlike the app's other period endpoints this one is not
 * cursor-paginated — it returns every client in one response — and it is
 * public (no session required), so `skipAuthRedirect` keeps a stray
 * 401/network hiccup from bouncing an anonymous visitor into the login flow.
 */
export async function fetchClientsVisitsReport(
  start: string,
  end: string,
): Promise<ClientVisitsReportItem[]> {
  const { data } = await http.get<ClientVisitsReportItem[]>('/persons/clients/visits-report', {
    params: {
      start_date: start,
      end_date: end,
    },
    skipAuthRedirect: true,
  })
  if (import.meta.env.DEV) {
    console.log('[fetchClientsVisitsReport] GET /persons/clients/visits-report response', data)
  }
  return data
}
